var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SRF',[_c('BoosBanner',{attrs:{"leaderList":_vm.leaderList}})],1),_c('SRF',[_c('OurTeam')],1),_c('SRF',[_c('PersonSwiper',{attrs:{"teamList":_vm.teamList}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }